module.exports = __webpack_public_path__ + "img/logo_beurer.939141cd.png";